var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('list',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList),expression:"showList"}],ref:"listComponent",on:{"onEdit":_vm.handleEdit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }